// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListeOffres_wrapper__2DSIf","title":"ListeOffres_title__22qM9","list":"ListeOffres_list__29FXj","item":"ListeOffres_item__3IBfY","cta":"ListeOffres_cta__29FxX"};